module.exports = __webpack_public_path__ + "img/banner2_3.5b9cb493.png";